import { getIcon } from "@/data/icons";

/**
 * PhotoPlaceholder — white background with a large lucide icon.
 * Used when there are no real customer photos yet.
 */
export default function PhotoPlaceholder({ iconName, label, dark = false, className = "" }) {
  const Icon = getIcon(iconName);
  return (
    <div
      className={`relative flex items-center justify-center w-full h-full bg-gradient-to-br from-white via-slate-50 to-slate-100 overflow-hidden ${className}`}
    >
      {/* Blueprint grid */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(#0ea5e9 1px, transparent 1px), linear-gradient(90deg, #0ea5e9 1px, transparent 1px)",
          backgroundSize: "26px 26px",
        }}
      />
      {/* Soft ambient light */}
      <div
        aria-hidden
        className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-sky-100/70 blur-3xl pointer-events-none"
      />

      <div className="relative flex flex-col items-center gap-2">
        <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-white shadow-sm ring-1 ring-slate-200 flex items-center justify-center transition-transform duration-500 group-hover:scale-105">
          <Icon
            className={`w-10 h-10 md:w-12 md:h-12 ${dark ? "text-slate-900" : "text-sky-500"}`}
            strokeWidth={1.6}
          />
        </div>
        {label && (
          <span className="text-[10px] font-semibold uppercase tracking-widest text-slate-500 mt-1">
            {label}
          </span>
        )}
      </div>

      <span className="absolute bottom-2.5 right-3 inline-flex items-center gap-1.5 text-[10px] font-medium text-slate-400/90 uppercase tracking-wider">
        <span className="w-1 h-1 rounded-full bg-slate-300" />
        Foto próximamente
      </span>
    </div>
  );
}
